import { useAdsContext } from "@/ads/context";
import { IS_SERVER } from "@/constants";
import { useConfig, useCustomerActionConfig, usePortal, } from "@/contexts/cdpConfig";
import { useClassified } from "@/contexts/classified";
import { useIsNewBuildProject } from "@/shared/hooks";
import { useTokens } from "@gemini/core";
import { useEffect, useRef, useState } from "react";
export function useCustomDataCollector() {
    var _a, _b;
    const [data, setData] = useState(null);
    const tokens = useTokens();
    const config = useConfig();
    const tokenString = (_a = config.customerActionSecrets) !== null && _a !== void 0 ? _a : "";
    const portal = usePortal();
    const customerActionEnabled = useCustomerActionConfig();
    const { targeting } = useAdsContext();
    const processedActions = useRef(new Set());
    // @ts-ignore
    const legacyId = (_b = useClassified()) === null || _b === void 0 ? void 0 : _b.metadata.legacyId;
    const isProject = useIsNewBuildProject();
    const isDesktop = IS_SERVER
        ? undefined
        : window.matchMedia(`(min-width: ${tokens["breakpoint.lg"] || 1024}px)`)
            .matches;
    useEffect(() => {
        setData({
            // @ts-ignore
            config: config,
            tokenString: tokenString,
            portal: portal,
            customerActionEnabled: customerActionEnabled,
            targetingVars: targeting,
            processedActions: processedActions,
            legacyId: legacyId,
            isDesktop: isDesktop,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            isCypress: typeof window.Cypress !== "undefined",
            isProject,
        });
    }, [
        isDesktop,
        config,
        tokenString,
        portal,
        customerActionEnabled,
        targeting,
        processedActions,
        legacyId,
        isProject,
    ]);
    return data;
}
